import {useCallback, useEffect, useState, useRef} from 'preact/hooks';
import {throttle} from 'lodash';

export const useQfScroll = id => {
    const [showElement, setShowElement] = useState(false);
    const handleScroll = useCallback(
        throttle(() => {
            const clients = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const showId = document.getElementById(id);
            setShowElement(showId.getBoundingClientRect().top <= clients);
        }, 300),
        [id]
    );

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', handleScroll);
        }
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const ua = navigator.userAgent;
        const isMobile = /Mobile|Android|iP(hone|od|ad)|IEMobile|Opera Mini/i.test(ua);
        setIsMobile(isMobile);
    }, []);

    return {
        showElement,
        handleScroll,
        isMobile
    };
};

export const useQfScreen = () => {
    const [screenWidth, setScreenWidth] = useState(null);

    const handleResize = useCallback(
        throttle(() => {
            setScreenWidth(window.innerWidth);
        }, 100),
        []
    );

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [screenWidth]);

    return {
        screenWidth,
        setScreenWidth
    };
};
